import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from './store';
import { useEffect } from 'react'

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAfterPaintEffect = (effect: any, dependencies: any[]) => {
    useEffect(() => {
        requestAnimationFrame(() => {
            setTimeout(() => {
                effect();
            }, 0);
        });
    }, dependencies);
}